/* Pikt custom checkout flow + Smarty REST address validation
 * Loaded by: sections/pikt-checkout.liquid
 */
(function () {
  'use strict';

  var SUBMIT_URL = '/apps/pikt/checkout/submit/';
  var SMARTY_AUTOCOMPLETE = 'https://us-autocomplete-pro.api.smarty.com/lookup';
  var SMARTY_INTL_AUTOCOMPLETE = 'https://international-autocomplete.api.smarty.com/v2/lookup';
  var SMARTY_VERIFY       = 'https://us-street.api.smarty.com/street-address';

  var FETCH_TIMEOUT_MS       = 25000;
  var SMARTY_TIMEOUT_MS      = 8000;
  var DEFAULT_COUNTRY        = 'US';
  var COUNTRY_CODE_PAIRS = 'AF:AFG,AX:ALA,AL:ALB,DZ:DZA,AS:ASM,AD:AND,AO:AGO,AI:AIA,AQ:ATA,AG:ATG,AR:ARG,AM:ARM,AW:ABW,AU:AUS,AT:AUT,AZ:AZE,BS:BHS,BH:BHR,BD:BGD,BB:BRB,BY:BLR,BE:BEL,BZ:BLZ,BJ:BEN,BM:BMU,BT:BTN,BO:BOL,BQ:BES,BA:BIH,BW:BWA,BV:BVT,BR:BRA,IO:IOT,BN:BRN,BG:BGR,BF:BFA,BI:BDI,CV:CPV,KH:KHM,CM:CMR,CA:CAN,KY:CYM,CF:CAF,TD:TCD,CL:CHL,CN:CHN,CX:CXR,CC:CCK,CO:COL,KM:COM,CG:COG,CD:COD,CK:COK,CR:CRI,CI:CIV,HR:HRV,CU:CUB,CW:CUW,CY:CYP,CZ:CZE,DK:DNK,DJ:DJI,DM:DMA,DO:DOM,EC:ECU,EG:EGY,SV:SLV,GQ:GNQ,ER:ERI,EE:EST,SZ:SWZ,ET:ETH,FK:FLK,FO:FRO,FJ:FJI,FI:FIN,FR:FRA,GF:GUF,PF:PYF,TF:ATF,GA:GAB,GM:GMB,GE:GEO,DE:DEU,GH:GHA,GI:GIB,GR:GRC,GL:GRL,GD:GRD,GP:GLP,GU:GUM,GT:GTM,GG:GGY,GN:GIN,GW:GNB,GY:GUY,HT:HTI,HM:HMD,VA:VAT,HN:HND,HK:HKG,HU:HUN,IS:ISL,IN:IND,ID:IDN,IR:IRN,IQ:IRQ,IE:IRL,IM:IMN,IL:ISR,IT:ITA,JM:JAM,JP:JPN,JE:JEY,JO:JOR,KZ:KAZ,KE:KEN,KI:KIR,KP:PRK,KR:KOR,KW:KWT,KG:KGZ,LA:LAO,LV:LVA,LB:LBN,LS:LSO,LR:LBR,LY:LBY,LI:LIE,LT:LTU,LU:LUX,MO:MAC,MG:MDG,MW:MWI,MY:MYS,MV:MDV,ML:MLI,MT:MLT,MH:MHL,MQ:MTQ,MR:MRT,MU:MUS,YT:MYT,MX:MEX,FM:FSM,MD:MDA,MC:MCO,MN:MNG,ME:MNE,MS:MSR,MA:MAR,MZ:MOZ,MM:MMR,NA:NAM,NR:NRU,NP:NPL,NL:NLD,NC:NCL,NZ:NZL,NI:NIC,NE:NER,NG:NGA,NU:NIU,NF:NFK,MK:MKD,MP:MNP,NO:NOR,OM:OMN,PK:PAK,PW:PLW,PS:PSE,PA:PAN,PG:PNG,PY:PRY,PE:PER,PH:PHL,PN:PCN,PL:POL,PT:PRT,PR:PRI,QA:QAT,RE:REU,RO:ROU,RU:RUS,RW:RWA,BL:BLM,SH:SHN,KN:KNA,LC:LCA,MF:MAF,PM:SPM,VC:VCT,WS:WSM,SM:SMR,ST:STP,SA:SAU,SN:SEN,RS:SRB,SC:SYC,SL:SLE,SG:SGP,SX:SXM,SK:SVK,SI:SVN,SB:SLB,SO:SOM,ZA:ZAF,GS:SGS,SS:SSD,ES:ESP,LK:LKA,SD:SDN,SR:SUR,SJ:SJM,SE:SWE,CH:CHE,SY:SYR,TW:TWN,TJ:TJK,TZ:TZA,TH:THA,TL:TLS,TG:TGO,TK:TKL,TO:TON,TT:TTO,TN:TUN,TR:TUR,TM:TKM,TC:TCA,TV:TUV,UG:UGA,UA:UKR,AE:ARE,GB:GBR,US:USA,UM:UMI,UY:URY,UZ:UZB,VU:VUT,VE:VEN,VN:VNM,VG:VGB,VI:VIR,WF:WLF,EH:ESH,YE:YEM,ZM:ZMB,ZW:ZWE'.split(',').reduce(function (codes, pair) {
    var parts = pair.split(':');
    codes[parts[0]] = parts[1];
    return codes;
  }, {});

  var root = document.querySelector('.pikt-checkout');
  var form = root && root.querySelector('[data-pikt-form]');
  if (!form) return;

  var SMARTY_KEY = (root.getAttribute('data-pikt-smarty-key') || '').trim();
  var SECONDARY  = root.getAttribute('data-pikt-smarty-secondary') === 'true';
  var REQUIRE_VERIFIED = root.getAttribute('data-pikt-smarty-require-verified') === 'true';

  var PHONE_DIAL_CODES = 'AF:93,AL:355,DZ:213,AS:1684,AD:376,AO:244,AI:1264,AG:1268,AR:54,AM:374,AW:297,AU:61,AT:43,AZ:994,BS:1242,BH:973,BD:880,BB:1246,BY:375,BE:32,BZ:501,BJ:229,BM:1441,BT:975,BO:591,BA:387,BW:267,BR:55,BN:673,BG:359,BF:226,BI:257,CV:238,KH:855,CM:237,CA:1,KY:1345,CF:236,TD:235,CL:56,CN:86,CO:57,KM:269,CG:242,CD:243,CK:682,CR:506,CI:225,HR:385,CU:53,CW:599,CY:357,CZ:420,DK:45,DJ:253,DM:1767,DO:1809,EC:593,EG:20,SV:503,GQ:240,ER:291,EE:372,ET:251,FJ:679,FI:358,FR:33,GF:594,PF:689,GA:241,GM:220,GE:995,DE:49,GH:233,GI:350,GR:30,GL:299,GD:1473,GP:590,GU:1671,GT:502,GG:44,GN:224,GW:245,GY:592,HT:509,HN:504,HK:852,HU:36,IS:354,IN:91,ID:62,IR:98,IQ:964,IE:353,IM:44,IL:972,IT:39,JM:1876,JP:81,JE:44,JO:962,KZ:7,KE:254,KI:686,KR:82,KW:965,KG:996,LA:856,LV:371,LB:961,LS:266,LR:231,LY:218,LI:423,LT:370,LU:352,MO:853,MG:261,MW:265,MY:60,MV:960,ML:223,MT:356,MH:692,MQ:596,MR:222,MU:230,MX:52,FM:691,MD:373,MC:377,MN:976,ME:382,MA:212,MZ:258,MM:95,NA:264,NR:674,NP:977,NL:31,NC:687,NZ:64,NI:505,NE:227,NG:234,NU:683,NF:672,MK:389,MP:1670,NO:47,OM:968,PK:92,PW:680,PA:507,PG:675,PY:595,PE:51,PH:63,PL:48,PT:351,PR:1787,QA:974,RE:262,RO:40,RU:7,RW:250,WS:685,SM:378,SA:966,SN:221,RS:381,SC:248,SL:232,SG:65,SK:421,SI:386,SB:677,SO:252,ZA:27,ES:34,LK:94,SD:249,SR:597,SE:46,CH:41,SY:963,TW:886,TJ:992,TZ:255,TH:66,TL:670,TG:228,TO:676,TT:1868,TN:216,TR:90,TM:993,TC:1649,TV:688,UG:256,UA:380,AE:971,GB:44,US:1,UY:598,UZ:998,VU:678,VA:39,VE:58,VN:84,VG:1284,VI:1340,YE:967,ZM:260,ZW:263'.split(',').reduce(function (codes, pair) {
    var parts = pair.split(':');
    codes[parts[0]] = parts[1];
    return codes;
  }, {});


  var fields = {
    country:  form.querySelector('[data-pikt-country]'),
    phone:    form.querySelector('[data-pikt-phone]'),
    phonePrefix: form.querySelector('[data-pikt-phone-prefix]'),
    phoneHelp: form.querySelector('[data-pikt-phone-help]'),
    address1: form.querySelector('[data-pikt-address1]'),
    address2: form.querySelector('[data-pikt-address2]'),
    city:     form.querySelector('[data-pikt-city]'),
    province: form.querySelector('[data-pikt-province]'),
    zip:      form.querySelector('[data-pikt-zip]')
  };

  var statusEl     = form.querySelector('[data-pikt-status]');
  var validationEl = form.querySelector('[data-pikt-validation]');
  var phoneValidationEl = form.querySelector('[data-pikt-phone-validation]');
  var submitBtn    = form.querySelector('[data-pikt-submit]');
  var submitLabel  = form.querySelector('[data-pikt-submit-label]');
  var submitSpinner = form.querySelector('[data-pikt-submit-spinner]');
  var honeypot     = form.querySelector('[name="website"]');
  var isSubmitting = false;

  var verifyState = null;
  var lastVerifiedKey = '';
  var autocompleteRequestId = 0;
  var verificationRequestId = 0;

  function countryCode() {
    return ((fields.country && fields.country.value) || root.getAttribute('data-pikt-store-country') || DEFAULT_COUNTRY).trim().toUpperCase();
  }

  function phoneDialCode() {
    return PHONE_DIAL_CODES[countryCode()] || '';
  }

  function updatePhonePresentation() {
    if (!fields.phone) return;
    var code = phoneDialCode();
    if (fields.phonePrefix) {
      fields.phonePrefix.textContent = code ? '+' + code : countryCode();
      fields.phonePrefix.setAttribute('aria-label', 'Country calling code ' + (code ? '+' + code : countryCode()));
    }
    fields.phone.placeholder = 'Phone number';
    if (fields.phoneHelp) fields.phoneHelp.textContent = 'Enter a valid phone number for the selected country.';
  }

  function smartySupportsCountry() {
    return countryCode() === 'US';
  }

  function smartySupportsAutocomplete() {
    return !!SMARTY_KEY;
  }

  function isInternationalCountry() {
    return countryCode() !== 'US';
  }

  function smartyCountryCode() {
    return COUNTRY_CODE_PAIRS[countryCode()] || countryCode();
  }

  function populateCountryOptions() {
    if (!fields.country || fields.country.tagName !== 'SELECT') return;
    var selected = countryCode();
    var displayNames = typeof Intl !== 'undefined' && Intl.DisplayNames
      ? new Intl.DisplayNames([document.documentElement.lang || 'en'], { type: 'region' })
      : null;
    var options = Object.keys(COUNTRY_CODE_PAIRS).sort().map(function (code) {
      var option = document.createElement('option');
      option.value = code;
      option.textContent = displayNames ? (displayNames.of(code) || code) : code;
      option.selected = code === selected;
      return option;
    }).reduce(function (fragment, option) {
      fragment.appendChild(option);
      return fragment;
    }, document.createDocumentFragment());
    fields.country.replaceChildren(options);
  }

  function setStatus(msg, isError) {
    if (!statusEl) return;
    statusEl.textContent = msg || '';
    statusEl.classList.toggle('pikt-error', !!isError);
  }

  function setPhoneValidation(msg) {
    if (fields.phone) {
      fields.phone.setCustomValidity(msg || '');
      fields.phone.setAttribute('aria-invalid', msg ? 'true' : 'false');
    }
    if (phoneValidationEl) {
      phoneValidationEl.textContent = msg || '';
      phoneValidationEl.classList.toggle('pikt-warn', !!msg);
    }
  }

  function phoneFormatter() {
    var library = window.libphonenumber;
    return library && library.AsYouType ? library : null;
  }

  function phoneValidator() {
    var library = window.libphonenumber;
    return library && library.isValidPhoneNumber ? library : null;
  }

  function formatPhoneInput() {
    if (!fields.phone) return;
    var value = fields.phone.value.trim();
    if (!value) return;
    var library = phoneFormatter();
    if (!library) return;

    var country = countryCode();
    var input = value;
    var libraryDigits = value.replace(/[^0-9]/g, '');
    var libraryDialCode = phoneDialCode();
    var stripVisiblePrefix = false;
    var hasInternationalPrefix = value.charAt(0) === '+';
    if (hasInternationalPrefix && libraryDialCode && libraryDigits.indexOf(libraryDialCode) === 0) {
      input = libraryDigits.slice(libraryDialCode.length);
      hasInternationalPrefix = false;
    }
    if (!hasInternationalPrefix && libraryDialCode && libraryDigits.charAt(0) !== '0') {
      input = '+' + libraryDialCode + input.replace(/[^0-9]/g, '');
      stripVisiblePrefix = true;
    }
    var formattedByLibrary = new library.AsYouType(country).input(input);
    if (stripVisiblePrefix) {
      formattedByLibrary = formattedByLibrary.replace(new RegExp('^\\+' + libraryDialCode + '\\s*'), '');
    }
    if (formattedByLibrary !== value) {
      fields.phone.value = formattedByLibrary;
      fields.phone.setSelectionRange(fields.phone.value.length, fields.phone.value.length);
    }
  }

  function validatePhone() {
    if (!fields.phone) return true;
    var value = fields.phone.value.trim();
    if (!value) {
      setPhoneValidation('');
      return true;
    }
    var library = phoneValidator();
    var valid = !!library && library.isValidPhoneNumber(value, countryCode());
    setPhoneValidation(valid ? '' : 'Enter a valid phone number for the selected country.');
    return valid;
  }

  function setValidation(msg, kind) {
    if (!validationEl) return;
    if (kind === 'warn') {
      validationEl.textContent = msg || '';
      validationEl.classList.add('pikt-warn');
    } else {
      validationEl.textContent = '';
      validationEl.classList.remove('pikt-warn');
    }
    validationEl.classList.remove('pikt-ok');
  }

  function setLoading(on) {
    if (submitBtn) {
      submitBtn.disabled = on;
      submitBtn.dataset.loading = on ? 'true' : 'false';
      submitBtn.setAttribute('aria-busy', on ? 'true' : 'false');
    }
    if (submitLabel) submitLabel.hidden = on;
    if (submitSpinner) submitSpinner.hidden = !on;
  }

  window.addEventListener('pageshow', function () {
    isSubmitting = false;
    setLoading(false);
  });

  function streetValue() {
    return (fields.address1.dataset.piktStreet || fields.address1.value || '').trim();
  }

  function formatFullAddress() {
    var street = fields.address1.dataset.piktStreet || fields.address1.value;
    var apt    = fields.address2.value;
    var line1  = street + (apt ? ' ' + apt : '');
    var regionZip = [fields.province.value, fields.zip.value].filter(Boolean).join(' ');
    return [line1, fields.city.value, regionZip].filter(Boolean).join(', ');
  }

  function clearSelection() {
    delete fields.address1.dataset.piktStreet;
    fields.address2.value = '';
    fields.city.value = '';
    fields.province.value = '';
    fields.zip.value = '';
  }

  function addressKey() {
    return [streetValue(), fields.address2.value, fields.city.value, fields.province.value, fields.zip.value].join('|').toUpperCase();
  }

  function invalidateVerification() {
    verifyState = null;
    lastVerifiedKey = '';
    verificationRequestId += 1;
    setValidation('', '');
  }

  function qs(params) {
    return Object.keys(params)
      .filter(function (k) { return params[k] !== undefined && params[k] !== null && params[k] !== ''; })
      .map(function (k) { return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]); })
      .join('&');
  }

  function fetchWithTimeout(url, opts, timeoutMs) {
    opts = opts || {};
    if (typeof AbortController === 'undefined') return fetch(url, opts);
    var ctl = new AbortController();
    var t = setTimeout(function () { ctl.abort(); }, timeoutMs || FETCH_TIMEOUT_MS);
    opts.signal = ctl.signal;
    return fetch(url, opts).finally(function () { clearTimeout(t); });
  }

  // ---- Suggestions dropdown ----
  var suggestionBox = null;
  var currentSuggestions = [];
  var activeIndex = -1;
  var autocompleteDebounce = null;

  function buildSuggestionBox() {
    suggestionBox = document.createElement('ul');
    suggestionBox.className = 'pikt-suggestions';
    suggestionBox.id = 'pikt-suggestions';
    suggestionBox.setAttribute('role', 'listbox');
    suggestionBox.style.cssText = 'position:absolute;z-index:9999;background:#fff;border:1px solid #ccc;list-style:none;margin:0;padding:0;max-height:260px;overflow:auto;width:100%;box-shadow:0 2px 8px rgba(0,0,0,.1);display:none;';
    var wrap = fields.address1.parentNode;
    wrap.style.position = 'relative';
    wrap.appendChild(suggestionBox);
  }

  function closeSuggestions() {
    autocompleteRequestId += 1;
    if (!suggestionBox) return;
    suggestionBox.style.display = 'none';
    currentSuggestions = [];
    activeIndex = -1;
    fields.address1.setAttribute('aria-expanded', 'false');
    fields.address1.removeAttribute('aria-activedescendant');
  }

  function setActiveIndex(idx) {
    if (!suggestionBox) return;
    var items = suggestionBox.children;
    if (!items.length) return;
    if (idx < 0) idx = items.length - 1;
    if (idx >= items.length) idx = 0;
    activeIndex = idx;
    for (var i = 0; i < items.length; i++) {
      if (i === idx) {
        items[i].classList.add('pikt-suggestion-active');
        items[i].setAttribute('aria-selected', 'true');
        fields.address1.setAttribute('aria-activedescendant', items[i].id);
        if (items[i].scrollIntoView) items[i].scrollIntoView({ block: 'nearest' });
      } else {
        items[i].classList.remove('pikt-suggestion-active');
        items[i].setAttribute('aria-selected', 'false');
      }
    }
  }

  function renderSuggestions(suggestions) {
    if (!suggestionBox) return;
    suggestionBox.innerHTML = '';
    currentSuggestions = suggestions || [];
    activeIndex = -1;
    if (!currentSuggestions.length) {
      closeSuggestions();
      return;
    }
    currentSuggestions.forEach(function (s, i) {
      var li = document.createElement('li');
      li.id = 'pikt-suggestion-' + i;
      li.setAttribute('role', 'option');
      li.setAttribute('aria-selected', 'false');
      li.textContent = formatSuggestion(s);
      li.style.cssText = 'padding:.5rem .75rem;cursor:pointer;border-bottom:1px solid #eee;';
      li.addEventListener('mouseenter', function(){ setActiveIndex(i); });
      li.addEventListener('mousedown', function (e) {
        e.preventDefault();
        selectSuggestion(s);
      });
      suggestionBox.appendChild(li);
    });
    suggestionBox.style.display = 'block';
    fields.address1.setAttribute('aria-expanded', 'true');
  }

  function formatSuggestion(s) {
    if (s.text || s.address_text) return s.text || s.address_text;
    var secondary = s.secondary ? (' ' + s.secondary) : '';
    var entries   = s.entries > 1 ? (' (' + s.entries + ' entries)') : '';
    return [s.street_line + secondary, s.city, [s.state, s.zipcode].filter(Boolean).join(' ')].filter(Boolean).join(', ') + entries;
  }

  function suggestionStreet(s) {
    return s.street_line || s.street || s.address_line_1 || s.address_text || s.text || '';
  }

  function suggestionCity(s) {
    return s.city || s.city_name || s.locality || '';
  }

  function suggestionRegion(s) {
    return s.state || s.state_name || s.province || s.province_name || s.administrative_area_short || s.administrative_area || '';
  }

  function suggestionPostalCode(s) {
    return s.zipcode || s.postal_code || '';
  }

  function expandInternationalSuggestion(s) {
    if (!s.address_id) return Promise.resolve(s);
    var url = SMARTY_INTL_AUTOCOMPLETE + '/' + encodeURIComponent(s.address_id);
    var params = { key: SMARTY_KEY, country: smartyCountryCode() };
    return fetchWithTimeout(url + '?' + qs(params), { method: 'GET' }, SMARTY_TIMEOUT_MS)
      .then(function (r) {
        if (!r.ok) throw new Error('international autocomplete ' + r.status);
        return r.json();
      })
      .then(function (data) {
        return (data && data.candidates && data.candidates[0]) || s;
      });
  }

  function selectSuggestion(s) {
    if (isInternationalCountry() && s.address_id && !s.street && !s.locality) {
      expandInternationalSuggestion(s)
        .then(selectSuggestion)
        .catch(function (err) {
          console.warn('[Pikt] Smarty international address lookup error:', err);
        });
      return;
    }
    if (!isInternationalCountry() && s.entries > 1 && SECONDARY) {
      var selectedStr = s.street_line + ' ' + s.secondary + ' (' + s.entries + ') ' + s.city + ' ' + s.state + ' ' + s.zipcode;
      doAutocomplete(s.street_line + ' ' + s.secondary, selectedStr);
      return;
    }

    var street = suggestionStreet(s);
    fields.address1.dataset.piktStreet = street;
    fields.address2.value = s.secondary || s.address_line_2 || '';
    fields.city.value = suggestionCity(s) || fields.city.value;
    fields.province.value = suggestionRegion(s) || fields.province.value;
    fields.zip.value = suggestionPostalCode(s) || fields.zip.value;
    fields.address1.value = isInternationalCountry() && !s.street && !s.locality
      ? (s.text || s.address_text || street)
      : formatFullAddress();
    closeSuggestions();
    invalidateVerification();
    verifyCurrentAddress();
  }

  function doAutocomplete(search, selected) {
    if (!smartySupportsAutocomplete()) return;
    var requestId = ++autocompleteRequestId;
    var international = isInternationalCountry();
    var params = { key: SMARTY_KEY, search: search };
    var endpoint = international ? SMARTY_INTL_AUTOCOMPLETE : SMARTY_AUTOCOMPLETE;
    if (international) {
      params.country = smartyCountryCode();
    } else {
      if (SECONDARY) params.source = 'all';
      if (selected) params.selected = selected;
    }

    fetchWithTimeout(endpoint + '?' + qs(params), { method: 'GET' }, SMARTY_TIMEOUT_MS)
      .then(function (r) {
        if (!r.ok) throw new Error('autocomplete ' + r.status);
        return r.json();
      }).then(function (data) {
        if (requestId !== autocompleteRequestId) return;
        renderSuggestions((data && (international ? data.candidates : (data.suggestions || data.results))) || []);
      }).catch(function (err) {
        if (requestId !== autocompleteRequestId) return;
        console.warn('[Pikt] Smarty autocomplete error:', err);
      });
  }

  function onAddress1Input() {
    autocompleteRequestId += 1;
    clearSelection();
    invalidateVerification();
    var val = fields.address1.value.trim();
    clearTimeout(autocompleteDebounce);
    if (val.length < 3) {
      closeSuggestions();
      return;
    }
    autocompleteDebounce = setTimeout(function(){ doAutocomplete(val); }, 180);
  }

  function onAddress1Keydown(e) {
    var open = suggestionBox && suggestionBox.style.display === 'block';
    if (!open && e.key !== 'ArrowDown') return;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      if (!open) {
        var val = fields.address1.value.trim();
        if (val.length >= 3) doAutocomplete(val);
        return;
      }
      setActiveIndex(activeIndex + 1);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setActiveIndex(activeIndex < 0 ? currentSuggestions.length - 1 : activeIndex - 1);
    } else if (e.key === 'Enter') {
      // If dropdown is open with items, select instead of submitting the form
      if (currentSuggestions.length) {
        e.preventDefault();
        selectSuggestion(currentSuggestions[activeIndex >= 0 ? activeIndex : 0]);
      }
    } else if (e.key === 'Escape') {
      e.preventDefault();
      closeSuggestions();
    }
  }

  function verifyCurrentAddress() {
    if (!SMARTY_KEY || !smartySupportsCountry()) return Promise.resolve(true);
    var key = addressKey();
    if (verifyState === 'ok' && key === lastVerifiedKey) return Promise.resolve(true);
    var requestId = ++verificationRequestId;

    var params = {
      key: SMARTY_KEY,
      street: streetValue(),
      secondary: fields.address2.value,
      city: fields.city.value,
      state: fields.province.value,
      zipcode: fields.zip.value,
      match: 'enhanced',
      candidates: 1
    };

    return fetchWithTimeout(SMARTY_VERIFY + '?' + qs(params), { method: 'GET' }, SMARTY_TIMEOUT_MS)
      .then(function (r) {
        if (!r.ok) throw new Error('verify ' + r.status);
        return r.json();
      })
      .then(function (results) {
        if (requestId !== verificationRequestId || key !== addressKey()) return false;
        var cand = results && results[0];
        if (!cand) {
          verifyState = 'bad';
          setValidation('We couldn’t verify this address with USPS. Please check it.', 'warn');
          return false;
        }
        var comp = cand.components || {};
        var analysis = cand.analysis || {};

        fields.address1.dataset.piktStreet = cand.delivery_line_1 || fields.address1.dataset.piktStreet;
        fields.address2.value = cand.delivery_line_2 || fields.address2.value;
        fields.city.value = comp.city_name || fields.city.value;
        fields.province.value = comp.state_abbreviation || fields.province.value;
        fields.zip.value = (comp.zipcode && comp.plus4_code)
          ? (comp.zipcode + '-' + comp.plus4_code)
          : (comp.zipcode || fields.zip.value);
        fields.address1.value = formatFullAddress();

        var dpv = analysis.dpv_match_code;
        if (dpv === 'Y' || dpv === 'S' || dpv === 'D') {
          verifyState = 'ok';
          lastVerifiedKey = addressKey();
          setValidation('', '');
          return true;
        }
        verifyState = 'bad';
        setValidation('Address found but USPS can’t confirm delivery. Please double-check.', 'warn');
        return false;
      })
      .catch(function (err) {
        if (requestId !== verificationRequestId || key !== addressKey()) return false;
        console.warn('[Pikt] Smarty verify error:', err);
        verifyState = 'bad';
        setValidation('Address verification failed. You can continue, but please double-check.', 'warn');
        return false;
      });
  }

  function bindFieldInvalidation() {
    if (fields.country) {
      fields.country.addEventListener('change', function () {
        updatePhonePresentation();
        if (fields.phone) {
          fields.phone.value = '';
          setPhoneValidation('');
        }
        closeSuggestions();
        invalidateVerification();
        fields.address1.value = '';
        fields.address2.value = '';
        fields.city.value = '';
        fields.province.value = '';
        fields.zip.value = '';
        setValidation(
          smartySupportsAutocomplete() ? '' : 'Address autocomplete is disabled (missing Smarty key).',
          smartySupportsAutocomplete() ? '' : 'warn'
        );
      });
    }
    if (fields.phone) fields.phone.addEventListener('input', function () {
      formatPhoneInput();
    });
    ['address2','city','province','zip'].forEach(function (k) {
      fields[k].addEventListener('input', function () { invalidateVerification(); });
      fields[k].addEventListener('blur', function () {
        if (allAddressFieldsFilled()) verifyCurrentAddress();
      });
    });
    fields.address1.addEventListener('input', onAddress1Input);
    fields.address1.addEventListener('keydown', onAddress1Keydown);
    fields.address1.addEventListener('blur', function () {
      setTimeout(closeSuggestions, 180);
    });
    // Close dropdown on click outside
    document.addEventListener('mousedown', function (e) {
      if (!suggestionBox) return;
      if (!suggestionBox.contains(e.target) && e.target !== fields.address1) {
        closeSuggestions();
      }
    });
  }

  function allAddressFieldsFilled() {
    return !!(
      fields.address1.dataset.piktStreet &&
      fields.city.value.trim() &&
      fields.province.value.trim() &&
      fields.zip.value.trim()
    );
  }

  function readAddress() {
    var d = new FormData(form);
    return {
      first_name: (d.get('first_name') || '').trim(),
      last_name:  (d.get('last_name')  || '').trim(),
      email:      (d.get('email')      || '').trim(),
      phone:      (d.get('phone')      || '').trim(),
      address1:   streetValue(),
      address2:   (d.get('address2')   || '').trim(),
      city:       (d.get('city')       || '').trim(),
      province:   (d.get('province')   || '').trim().toUpperCase(),
      zip:        (d.get('zip')        || '').trim(),
      country:    countryCode()
    };
  }

  function getCart() {
    return fetchWithTimeout('/cart.js', { headers: { Accept: 'application/json' } }, FETCH_TIMEOUT_MS)
      .then(function (r) {
        if (!r.ok) throw new Error('Could not read your cart.');
        return r.json();
      });
  }

  function postJSON(url, body) {
    return fetchWithTimeout(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }, FETCH_TIMEOUT_MS).then(function (r) {
      return r.text().then(function (text) {
        var json;
        try { json = text ? JSON.parse(text) : {}; } catch (e) { json = { raw: text }; }
        if (!r.ok) throw new Error((json && json.error) ? json.error : ('Request failed (' + r.status + ')'));
        return json;
      });
    });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    formatPhoneInput();
    if (!validatePhone() || isSubmitting || !form.reportValidity()) return;

    // Honeypot: silently drop on bot submissions.
    if (honeypot && honeypot.value) {
      setLoading(true);
      setTimeout(function () { setLoading(false); }, 1500);
      return;
    }

    if (!allAddressFieldsFilled()) {
      setValidation('Please select a valid address from the suggestions.', 'warn');
      setStatus('Please select a valid address before continuing.', true);
      return;
    }

    isSubmitting = true;
    setStatus('', false);
    setLoading(true);
    var gateCheck = (SMARTY_KEY && REQUIRE_VERIFIED) ? verifyCurrentAddress() : Promise.resolve(true);
    gateCheck.then(function (verified) {
      if (SMARTY_KEY && REQUIRE_VERIFIED && !verified) {
        isSubmitting = false;
        setLoading(false);
        setStatus('Please correct the address before continuing.', true);
        return;
      }
      doSubmit();
    });
  });

  function doSubmit() {
    getCart()
      .then(function (cart) {
        if (!cart || !cart.items || cart.items.length === 0) throw new Error('Your cart is empty.');
        return postJSON(SUBMIT_URL, {
          cart_token: cart.token,
          address: readAddress(),
          lines: cart.items.map(function (item) {
            return { handle: item.handle, quantity: item.quantity, variant_id: String(item.variant_id) };
          })
        });
      })
      .then(function (order) {
        if (order && order.status && order.status !== 'issued') throw new Error('Order not issued (status: ' + order.status + ').');
        var invoiceUrl = order && (order.invoice_url || order.invoiceUrl);
        if (!invoiceUrl) throw new Error('No invoice URL returned.');
        window.location.href = invoiceUrl;
      })
      .catch(function (err) {
        isSubmitting = false;
        setLoading(false);
        var msg = (err && err.name === 'AbortError')
          ? 'The request took too long. Please try again.'
          : (err && err.message) || 'We could not create your checkout. Please try again.';
        setStatus(msg, true);
      });
  }

  populateCountryOptions();
  updatePhonePresentation();
  if (SMARTY_KEY) buildSuggestionBox();
  bindFieldInvalidation();
  if (!SMARTY_KEY) setValidation('Address autocomplete is disabled (missing Smarty key).', 'warn');
})();
